export default __webpack_public_path__ + "static/media/sunburst.0838324a.svg";